'use strict';

var React = require('react');

var SvgReceiptRupeeFilledIcon = function SvgReceiptRupeeFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.142 16.934a1 1 0 0 1-.642-.934v-11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v11a1 1 0 0 1-1.743.669l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.486 0l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.101.265Zm6.747-3.79a.75.75 0 0 0-.246-1.033l-1.713-1.054a2.485 2.485 0 0 0 1.07-2.045v-.012h1.25a.75.75 0 0 0 0-1.5h-1.25v-1h1.25a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h1.75v1h-1.75a.75.75 0 0 0 0 1.5h1.75v.012a.988.988 0 0 1-.988.988c-.903 0-1.238 1.184-.47 1.657l2.815 1.732a.75.75 0 0 0 1.032-.246Z"
  }));
};
SvgReceiptRupeeFilledIcon.displayName = "ReceiptRupeeFilledIcon";

exports.SvgReceiptRupeeFilledIcon = SvgReceiptRupeeFilledIcon;
